import React from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@material-ui/core';
import { Menu, Close } from '@material-ui/icons';

export function HamburgerMenuButton({ isOpen, className, onClick }) {
  return (
    <>
      <IconButton aria-label="Hamburger Menu Button" onClick={onClick} className={className} disableRipple>
        { isOpen ? (<Close className={className} />) : (<Menu className={className} />)}
      </IconButton>
    </>
  );
}

HamburgerMenuButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
};
